
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showWhatsAppMenu, setShowWhatsAppMenu] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const whatsappNumbers = [
    { state: 'Distrito Federal', number: '5561998017669' },
    { state: 'São Paulo', number: '5511920545233' },
    { state: 'Minas Gerais', number: '5531996645637' },
    { state: 'Mato Grosso do Sul', number: '5567998010523' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-[#97BC62] shadow-md z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="p-2 rounded-lg">
              <img 
                src="https://static.readdy.ai/image/c2ffb6ae5c67efb323410a310538f1c7/b294b7a2202c93a02cae1a0f9146a692.png"
                alt="InbraPrev"
                className="h-12"
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer">
              HOME
            </Link>
            <button 
              onClick={() => scrollToSection('quemsomos')}
              className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
            >
              QUEM SOMOS
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
            >
              SERVIÇOS
            </button>
            <button 
              onClick={() => scrollToSection('depoimentos')}
              className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
            >
              DEPOIMENTOS
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
            >
              CONTATO
            </button>
          </nav>

          {/* WhatsApp Icon with Dropdown */}
          <div className="hidden md:flex items-center gap-4">
            <div className="relative">
              <button
                onClick={() => setShowWhatsAppMenu(!showWhatsAppMenu)}
                className="w-10 h-10 flex items-center justify-center text-white hover:text-[#25D366] transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </button>

              {/* Dropdown Menu */}
              {showWhatsAppMenu && (
                <>
                  {/* Overlay to close menu when clicking outside */}
                  <div 
                    className="fixed inset-0 z-40"
                    onClick={() => setShowWhatsAppMenu(false)}
                  ></div>
                  
                  <div className="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                    <div className="px-4 py-2 text-sm font-semibold text-gray-700 border-b border-gray-200">
                      Escolha sua unidade:
                    </div>
                    {whatsappNumbers.map((item) => (
                      <a
                        key={item.state}
                        href={`https://wa.me/${item.number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 px-4 py-3 hover:bg-[#25D366]/10 transition-colors cursor-pointer"
                        onClick={() => setShowWhatsAppMenu(false)}
                      >
                        <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center">
                          <i className="ri-whatsapp-fill text-white text-sm"></i>
                        </div>
                        <span className="text-gray-700 font-medium">{item.state}</span>
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/20">
            <nav className="flex flex-col gap-4">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className="text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
              >
                HOME
              </Link>
              <button 
                onClick={() => scrollToSection('quemsomos')}
                className="text-left text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
              >
                QUEM SOMOS
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-left text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
              >
                SERVIÇOS
              </button>
              <button 
                onClick={() => scrollToSection('depoimentos')}
                className="text-left text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
              >
                DEPOIMENTOS
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-left text-white hover:text-[#2C5F2D] font-semibold transition-colors cursor-pointer"
              >
                CONTATO
              </button>
              
              <div className="flex items-center gap-4 pt-4 border-t border-white/20">
                <a 
                  href="https://wa.me/5521974621850" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center text-white hover:text-[#25D366] transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
